// extracted by mini-css-extract-plugin
export default {"root":"BasePage_root__u6hBV","main":"BasePage_main__q9I2O","container":"BasePage_container__1pC5r"};